/* tslint:disable:variable-name */
import {MasterService} from './../../services/master.service';
import {UserModalComponent} from './../../../shared/user-modal/user-modal.component';
import {Component, OnInit ,Input, Output, EventEmitter} from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {AutofillMonitor} from '@angular/cdk/text-field';
import {StockService} from '../../services/stocks.service';
import {PaginationInstance} from 'ngx-pagination';
import {DeleteModalService} from '../../services/delete-modal.service';
import { PageEvent } from '@angular/material/paginator';
import {CommonAlertService} from "../../../services/common-alert.service";

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit {
  public filter: any;
  public users: any;
  // tslint:disable-next-line:variable-name
  total_count: number;
  // tslint:disable-next-line:variable-name
  current_page: number;
  // tslint:disable-next-line:variable-name
  last_page: number;
  // tslint:disable-next-line:variable-name
  per_page: number;
  stockPageId = 'stockPageId';
  pageEvent: PageEvent;
  paginationID = 'listing_pagination';
  public selectedIndex = 0;
  public searchBy: any = 0;
  public searchTxt: any;
  placeHolder: any = 'Search By First  Name';
  @Input() id: string;
  @Input() maxSize: number;
  @Output() pageChange: EventEmitter<number>;
  itemToBePushed: any;

  public config: PaginationInstance = {
    id: 'custom',
    itemsPerPage: 10,
    currentPage: 1
  };
  //public childMessage = 'listing_pagination';
  bool = false;
  public viewPermission = false;
  public addPermission = false;
  public editPermission = false;
  public deletePermission = false;
  // tslint:disable-next-line:max-line-length
  constructor(public dialog: MatDialog, public stockService: StockService, public masterService: MasterService, public deleteModalService: DeleteModalService, public commonAlertService: CommonAlertService) {
  }
  ngOnInit() {
    // @ts-ignore
    // tslint:disable-next-line:triple-equals
    if (localStorage.getItem('roleId') == 0) {
      // @ts-ignore
      // tslint:disable-next-line:max-line-length
      this.viewPermission = this.addPermission = this.editPermission = this.deletePermission = true;
    } else {
      const roles = JSON.parse(localStorage.getItem('roles'));
      // tslint:disable-next-line:triple-equals max-line-length
      if (roles['more.users.view'] == 1 || roles['more.users.add'] == 1 || roles['more.users.edit'] == 1 || roles['more.users.delete'] == 1) {
        this.viewPermission = true;
      }
      // tslint:disable-next-line:triple-equals
      if (roles['more.users.add'] == 1) {
        this.addPermission = true;
      }
      // tslint:disable-next-line:triple-equals
      if (roles['more.users.edit'] == 1) {
        this.editPermission = true;
      }
      // tslint:disable-next-line:triple-equals
      if (roles['more.users.delete'] == 1) {
        this.deletePermission = true;
      }
    }
    this.filter = {
      token: localStorage.getItem('token')
    };
    this.getData();
  }
  getData() {
    this.masterService.getIndex('/users/index', this.filter).subscribe(res => {
      // @ts-ignore
      this.users = res.data.items;
      // @ts-ignore
      this.total_count = res.data.total;
      // @ts-ignore
      this.last_page = res.data.last_page;
      // @ts-ignore
      this.per_page = res.data.per_page;
      this.itemToBePushed = (this.last_page * this.per_page) - this.total_count;
      this.total_count = this.total_count + (this.last_page * this.per_page - this.total_count);
      // @ts-ignore
      this.current_page = res.data.current_page;
      this.bool = true;
      const newData = {
        id: '',
        name: ''
      };
      // @ts-ignore
      
      if (this.users.length < 10) {
        for ( let i = this.users.length; i < 9 ; i++) {
        //for ( let i = 0; i < 9 ; i++) {
          this.users.push(newData);
        }
      }
      // @ts-ignore
      if(res.data.total == 0){ 
       this.commonAlertService.showEmptyMsg({message: 'No Details Found.'})
      }
    });
  }
  getSearchValue() {
    if (this.searchBy) {
      switch (this.searchBy) {
        case '0':
          this.placeHolder = 'Search By First Name';
          break;
          case '1':
          this.placeHolder = 'Search By Last Name';
          break;
          case '2':
          this.placeHolder = 'Search By Email';
          break;
          case '3':
          this.placeHolder = 'Search By User Name';
          break;
          case '4':
          this.placeHolder = 'Search By Role';
          break;
        default: this.placeHolder = 'Search By First Name';
      }
    }
  }

  openDialog() {
    const dialogRef = this.dialog.open(UserModalComponent, {
    //  minHeight: '500px',
      minWidth: '50vw',
      disableClose: true,
      autoFocus: true
    }).afterClosed().subscribe(() => this.getData());
  }
  
  editDialog(index, type) {
    const showForm = type;
    const editId = this.users[index].id;
    const encID = this.users[index].enc_id;
    // tslint:disable-next-line:triple-equals
    if ( editId != undefined && encID != undefined) {
      const dialogRef = this.dialog.open(UserModalComponent, {
        minWidth: (showForm === 'edit') ? '50vw' : '30vw',
        disableClose: true,
        data: {
          id: editId,
          enc_Id: encID,
          type: showForm
        } 
      }).afterClosed().subscribe(() => this.getData());
    }
  }
  // Delete the purchase order
  deleteDialog(i): void {
    this.deleteModalService.openModal({
      id: this.users[i].id,
      encId: this.users[i].enc_id,
      token: localStorage.getItem('token'),
      deleteUrl: '/users/destroy'
    });

    this.deleteModalService.closed.subscribe(() => {
      this.getData();
    });
  }

  selectRow(index: number) {
    this.selectedIndex = index;
  }

  openEditDialog(index): void {
    // console.log('items', index);
    const editId = this.users[index].id;
    const encID = this.users[index].enc_id;
    // this.masterService.getRecordById();

    // tslint:disable-next-line:triple-equals
    if (editId != undefined && encID != undefined) {
      const dialogRef = this.dialog.open(UserModalComponent, {
        minWidth: '50vw',
        disableClose: true,
        data: {
          id: editId,
          enc_Id: encID,
          type: 'edit'
        }
      }).afterClosed().subscribe(() => this.getData());
    }

  }

  doSearch(): void {

  if (this.searchBy != null) {
      switch (this.searchBy) {
         case '0':
           Object.assign(this.filter, {search: { type: 'str', field: 'users.first_name', text: this.searchTxt}});
           break;
           case '1':
           Object.assign(this.filter, {search: { type: 'str', field: 'users.last_name', text: this.searchTxt}});
           break;
           case '2':
           Object.assign(this.filter, {search: { type: 'str', field: 'users.email', text: this.searchTxt}});
           break;
           case '3':
           Object.assign(this.filter, {search: { type: 'str', field: 'users.username', text: this.searchTxt}});
           break;
           case '4':
           Object.assign(this.filter, {search: { type: 'str', field: 'users.role', text: this.searchTxt}});
           break;
         default:
           Object.assign(this.filter, {search: { type: 'str', field: 'users.first_name', text: this.searchTxt}});
      }
    }
  this.getData();
  }

  doRefresh(): void {
     this.searchTxt = null;
     this.filter = {
       token: localStorage.getItem('token')
     };
     this.getData();
  }

  doPaginate(e): void {
    Object.assign(this.filter, {page: e});
    this.getData();
  }
}



